import React from 'react';
import { useT } from '@transifex/react';
import { useIntl } from 'react-intl';
import messages from '../../messages';

import * as S from './styles';
import { Sort } from './Sort';

export const BankFilterBar = ({ sortBy, onChange, total }) => {
  const t = useT();
  const { formatNumber } = useIntl();

  return (
    <S.FilterContainer container>
      <S.TotalBanks variant="h5">
        {t(messages.banksListTotal, { count: formatNumber(total) })}
      </S.TotalBanks>
      <Sort sortBy={sortBy} onChange={onChange} />
    </S.FilterContainer>
  );
};
